import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useStores } from '@/hooks/use-stores';
import { observer } from 'mobx-react';
import { StyledModal } from './DesktopUploadWizzard.styles';
import { DESKTOP_STEPS } from './DesktopUploadWizzard.consts';

interface Props {
  open: boolean;
  onClose: () => void;
  onComplete: () => void;
}

export const DesktopUploadWizzard: FC<Props> = observer(({ open, onClose, onComplete }) => {
  const { t } = useTranslation();
  const { imageUploadStore } = useStores();

  const { label, component: Step } = DESKTOP_STEPS[imageUploadStore.currentStep];

  return (
    <StyledModal
      zIndex={1201}
      centered
      open={open}
      footer={null}
      title={<p className="modal-title">{t(label)}</p>}
      onCancel={onClose}
      maskClosable={false}
      destroyOnClose
    >
      <div className="modal-content">
        <Step onComplete={onComplete} layout="desktop" />
      </div>
    </StyledModal>
  );
});
